import ResponsiveHeaderMenu from './NavBar2';

const Header = () => {
    return (
        <ResponsiveHeaderMenu/>
    )
}

export default Header;